// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {
    height: 100vh;
    background-color: #150620;
    background-image: linear-gradient(213deg, #150620 0%, #150620 50%, #2B86C5 100%);
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
  }
  
  #main{
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-top: 2rem;
  }
  .main-heading{
    font-size: 1.5rem;
 
  }
  @media screen and (max-width: 45em) {
    #main{
      flex-direction: column;
      align-items: center;
    }
    .main-heading{
      font-size: 1.3rem;
    }
  }
  .App {
    text-align: center;
  }
  
  .App-header {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }
  
  .App-link {
    color: #61dafb;
  }
  .login-button{
    background-color: #61dafb;
    color: #23252C;
    padding: 1rem 2rem;
    border: none;
    border-radius: 0.5rem;
    text-align: center;
    align-items: center;
    display: block;
    margin: 0 auto;
  }
           
  .login-button {
    background-image: linear-gradient(to right, #DD5E89 0%, #F7BB97  51%, #DD5E89  100%);
    margin: 10px;
    padding: 15px 45px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;            
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
    margin: 0 auto;
  }

  .login-button:hover {
    background-position: right center;
    color: #fff;
    text-decoration: none;
  }

  .web3button {
    border-color: white;
    background-color: transparent;
    color:#fff;
    display: block;
    margin: 0 auto;
    padding: 12px 30px;
    border: 2px solid #E8E8E8;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
  }

  .web3button:hover {
    background-position: right center;
    color: #fff;
    text-decoration: none;
    box-shadow: 0 0 20px #eee;
  }
 `, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,gFAAgF;IAChF,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,iBAAiB;;EAEnB;EACA;IACE;MACE,sBAAsB;MACtB,mBAAmB;IACrB;IACA;MACE,iBAAiB;IACnB;EACF;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,oFAAoF;IACpF,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,iCAAiC;IACjC,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;IACV,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,WAAW;IACX,qBAAqB;IACrB,yBAAyB;EAC3B","sourcesContent":["*{\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  body {\n    height: 100vh;\n    background-color: #150620;\n    background-image: linear-gradient(213deg, #150620 0%, #150620 50%, #2B86C5 100%);\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-attachment: fixed;\n  }\n  \n  #main{\n    display: flex;\n    justify-content: center;\n    gap: 1rem;\n    margin-top: 2rem;\n  }\n  .main-heading{\n    font-size: 1.5rem;\n \n  }\n  @media screen and (max-width: 45em) {\n    #main{\n      flex-direction: column;\n      align-items: center;\n    }\n    .main-heading{\n      font-size: 1.3rem;\n    }\n  }\n  .App {\n    text-align: center;\n  }\n  \n  .App-header {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n  }\n  \n  .App-link {\n    color: #61dafb;\n  }\n  .login-button{\n    background-color: #61dafb;\n    color: #23252C;\n    padding: 1rem 2rem;\n    border: none;\n    border-radius: 0.5rem;\n    text-align: center;\n    align-items: center;\n    display: block;\n    margin: 0 auto;\n  }\n           \n  .login-button {\n    background-image: linear-gradient(to right, #DD5E89 0%, #F7BB97  51%, #DD5E89  100%);\n    margin: 10px;\n    padding: 15px 45px;\n    text-align: center;\n    text-transform: uppercase;\n    transition: 0.5s;\n    background-size: 200% auto;\n    color: white;            \n    box-shadow: 0 0 20px #eee;\n    border-radius: 10px;\n    display: block;\n    margin: 0 auto;\n  }\n\n  .login-button:hover {\n    background-position: right center;\n    color: #fff;\n    text-decoration: none;\n  }\n\n  .web3button {\n    border-color: white;\n    background-color: transparent;\n    color:#fff;\n    display: block;\n    margin: 0 auto;\n    padding: 12px 30px;\n    border: 2px solid #E8E8E8;\n    text-align: center;\n    text-transform: uppercase;\n    transition: 0.5s;\n  }\n\n  .web3button:hover {\n    background-position: right center;\n    color: #fff;\n    text-decoration: none;\n    box-shadow: 0 0 20px #eee;\n  }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
